import { render, staticRenderFns } from "./MemberItem.vue?vue&type=template&id=43e8fd38&scoped=true&"
import script from "./MemberItem.vue?vue&type=script&lang=js&"
export * from "./MemberItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8fd38",
  null
  
)

export default component.exports